import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppSettings } from './settings';
import { ResponseModel } from '../models/response-model';
import { UserModel } from '../models/user-model';


@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) {
   }

   private rutaApi:string = AppSettings.apiEndpoint;
   private path:string = "";
   private produccion:boolean = AppSettings.produccion;
   public response: any;


    async actualizarUsuario(nroCuenta:String,nroCli:String, nroProv:String,mail:String,repMail:String,pass:String,repPass:String,celular:String,telefono:String){
    if(nroCuenta==null||nroCuenta==undefined){ nroCuenta=''; }
    if(nroCli==null||nroCli==undefined){ nroCli=''; }
    if(nroProv==null||nroProv==undefined){ nroProv=''; }
    if(mail==null||mail==undefined){ mail=''; }
    if(repMail==null||repMail==undefined){ repMail=''; }
    if(pass==null||pass==undefined){ pass=''; }
    if(repPass==null||repPass==undefined){ repPass=''; }
    if(celular==null||celular==undefined){ celular=''; }
    if(telefono==null||telefono==undefined){ telefono=''; }

    if(mail != repMail){ return new ResponseModel("1","Los mails no coinciden"); }
    if(pass != repPass){ return new ResponseModel("1","Las contraseñas no coinciden"); }

    if(this.produccion){ this.path = this.rutaApi+'actualizar_usuario.php';}
    else { this.path = '/api/setUser'; }

    const params={
      'cliente': nroCuenta,
      'login': 'N',
      'nro_cliente' : nroCli,
      'nro_proovedor': nroProv,
      'mail': mail,
      'repMail': repMail,
      'pass':pass,
      'repPass':repPass,
      'celular':celular,
      'telefono':telefono
  }

  const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
  let response = await this.http.post<UserModel>(this.path,params,{headers}).toPromise();
    

    return response;
   }


   async consulUser (nroCuenta:String,nroCli:String, nroProv:String) {
    if(nroCuenta==null){ nroCuenta=''; }
    if(nroCli==null){ nroCli=''; }
    if(nroProv==null){ nroProv=''; }

    if(this.produccion){ this.path = this.rutaApi+'consultar_datos.php';}
    else { this.path = '/api/consulUser'; }

    const params={
      'cliente': nroCuenta,
      'login': 'N',
      'nro_cliente' : nroCli,
      'nro_proovedor': nroProv
    }

    const headers = new HttpHeaders({ 'Content-Type': 'application/json'}); //T0D0 GENERALIZAR
    let response = await this.http.post<any>(this.path,params,{headers}).toPromise();
    
        return  new UserModel(response[0].mail, response[0].telefono, response[0].celular, response[0].razon);




   }
}
